import { jsx, Fragment } from 'react/jsx-runtime';
import { useMemo, useRef, useEffect } from 'react';
import { usePDFContent } from './PDF.js';
import RowPage from './RowPage.js';
import { styled } from 'styled-components';
import { useInViewWithinRadixScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { useDebounce } from '@fabric-app/hooks/useDebounce';

const RowPageList = ({ width }) => {
  const { pdf, isReady } = usePDFContent();
  const pdfPages = useMemo(() => Array.from(Array(pdf?.numPages ?? 0).keys()), [
    pdf
  ]);
  if (!isReady) return null;
  return /* @__PURE__ */ jsx(Fragment, {
    children: pdfPages.map((index) => {
      const pageNumber = index + 1;
      return /* @__PURE__ */ jsx(RowPageC, {
        pageNumber,
        width
      }, pageNumber);
    })
  });
};
const RowPageC = ({ pageNumber, width }) => {
  const { getEstimatedHeight, updateCurrentPage } = usePDFContent();
  const containerRef = useRef(null);
  const isInView = useInViewWithinRadixScrollArea(containerRef, {
    margin: "1000px 0px 1000px 0px"
  });
  const debouncedIsInView = useDebounce(isInView, 250);
  useEffect(() => {
    if (debouncedIsInView) {
      updateCurrentPage();
    }
  }, [
    debouncedIsInView,
    updateCurrentPage
  ]);
  return /* @__PURE__ */ jsx(RowPageContainer, {
    ref: containerRef,
    "data-page-index": pageNumber,
    style: {
      width,
      height: getEstimatedHeight(pageNumber, width, true)
    },
    children: isInView ? /* @__PURE__ */ jsx(RowPage, {
      pageNumber,
      width
    }) : null
  }, pageNumber);
};
const RowPageContainer = styled.div.withConfig({
  displayName: "RowPageList__RowPageContainer",
  componentId: "sc-cb798b1f-0"
})([
  `overflow:hidden;background-color:white;position:relative;&:not(:first-child){border-top:rgba(0,0,0,0.05) 1px solid;}`
]);

export { RowPageList as default };
//# sourceMappingURL=RowPageList.js.map
